import React, { useContext, useEffect, useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Image } from "primereact/image";
import { applicationsService } from "../../services/ApplicationsService";
import { votersService } from "../../services/VotersService";
import { formatDate, formatDateTimeSeconds } from "../../config/Config";
import "./ViewApplication.css";
import { Tooltip } from "primereact/tooltip";
import {
	APPLICATION_STATUS_APPROVED,
	APPLICATION_STATUS_REJECTED,
	APPLICATION_TYPE_AMENDMENT,
	APPLICATION_TYPE_MIGRATION,
	APPLICATION_TYPE_OBJECTION,
	APPLICATION_TYPE_REGISTRATION,
	APPLICATION_TYPE_REINSTATEMENT,
	APPLICATION_TYPE_REMOVAL,
	APPLICATION_TYPE_SUSPENSION,
	APPLICATION_TYPE_TRANSFER,
	APPLICATION_TYPE_CORRECTION
} from "../../constants";
import ScreenLoader from "../../componets/ScreenLoader";
import DelimitationView from "./DelimitationView";
import { Calendar } from "primereact/calendar";
import { InputText } from "primereact/inputtext";
import { SelectButton } from "primereact/selectbutton";
import { Dropdown } from "primereact/dropdown";
import { AppDB } from "../../App";
import EditRegistrationDialog from "./EditApplicationDialog";
import { Badge } from "primereact/badge";
import { changeLang } from "../../componets/Language/ChangeLang";
import GenericUploadFileTable from "../../componets/GenericUploadFileTable";
import { usersService } from "../../services/UsersService";
import { set } from "lodash";
import { Divider } from "primereact/divider";
import { splitNameFields } from "../../componets/utils/nameUtils";

///isVoter  if not not an application
export default function ({
	myVoter,
	myAppication,
	applicationID,
	applicationTypeID,
	idNumber,
	loading,
	setLoading,
	visible = false,
	onHide = () => { }
}) {
	var [voter, setVoter] = useState(myVoter || null);
	const [application, setApplication] = useState(voter?.application || myAppication || null);

	const [applicationRules, setApplicationRules] = useState([]);
	const [rulesLoading, setRulesLoading] = useState(true);
	const [binaryLoading, setBinaryLoading] = useState(true);
	const [binaryData, setBinaryData] = useState([]);

	var [notitication, setNotitication] = useState([]);
	var { permission, toast, lookUp, setShowEditRegistration } = useContext(AppDB);
	// lookUp
	function convertDataStructure(res) {
		let output = [];

		// Handle case where there's only one item
		if (res.length === 1) {
			let obj = {};
			obj.col1 = res[0]; // Only one item, so it becomes col1
			obj.col2 = null; // No pair, so col2 is null
			output.push(obj);
		} else {
			// Loop through the array in steps of 2 (skip every other item)
			for (let index = 0; index < res.length; index += 3) {
				let obj = {};
				const col1 = res[index]; // col1 is always the current item

				// Check if the next item exists for col2
				const col2 = res[index + 1] || null; // If there's no next item, set col2 to null
				const col3 = res[index + 2] || null; // If there's no next item, set col3 to null

				obj.col1 = col1;
				obj.col2 = col2;
				obj.col3 = col3;

				output.push(obj);
			}
		}

		return output;
	}



	function renderColumnRule(row, selecteRow) {
		return (
			<div className="flex  align-items-center">
				<>
					{row[selecteRow] !== null && (
						<>
							{!row[selecteRow]?.processed ? (
								<i
									style={{ fontSize: 10, width: 30, height: 30 }}
									className="p-button-secondary p-button-rounded   p-button p-component p-button-icon-only pi pi-exclamation-triangle"
								></i>
							) : row[selecteRow]?.broken ? (
								<i
									style={{ fontSize: 10, width: 30, height: 30 }}
									className="p-button-danger p-button-rounded   p-button p-component p-button-icon-only pi pi-times"
								></i>
							) : (
								<i
									style={{ fontSize: 10, width: 30, height: 30 }}
									className="pi pi-check  p-button-success p-button-rounded p-button p-component p-button-icon-only"
								></i>
							)}

							<b className="ml-3">{row[selecteRow]?.name || ""}</b>
						</>
					)}
				</>
			</div>
		);
	}

	useEffect(() => {
		setLoading(true);
		async function LoadingData() {
			var id = voter?.applicationID || applicationID;

			if (voter === null) {
				var applicationRes = await applicationsService.getByID(id);
				applicationRes = applicationRes?.data
				setApplication(applicationRes);

				var res = {};
				if (applicationRes?.applicationTypeID == APPLICATION_TYPE_AMENDMENT) {
					var resVoter = await votersService.getAmendmentOriginalDetailsByApplicationID(applicationRes?.applicationID);
					var res = await votersService.getByIDNumber(idNumber);
					setVoter({ ...res, ...resVoter });
				} else {
					var res = await votersService.getByIDNumber(idNumber);
					setVoter(res);
				}
				setVoter(res);

				// debugger;
				if (applicationRes.applicationTypeID == APPLICATION_TYPE_REMOVAL) {
					applicationsService.getRemovalBinaryDataByID(id).then((res) => {
						setBinaryData(res);
						setBinaryLoading(false);
					});
				} else {
					applicationsService.getBinaryDataByID(id).then((res) => {
						setBinaryData(res);
						setBinaryLoading(false);
					});
				}

				applicationsService.getRulesByID(id).then((res) => {
					setApplicationRules(convertDataStructure(res));
					setRulesLoading(false);
				});

				var res = await applicationsService.getNotificationsByID(id);
				setNotitication(res);

				setTimeout(() => {
					setLoading(false);
				}, 1000);
			}
		}

		LoadingData();
	}, []);

	const header = (name, edit = "") => (
		<div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
			<h5 className="m-0">
				<b>{name}</b>
			</h5>
			{edit}
		</div>
	);

	const binaryDataBodyTemplate = (rowData) => {
		return <Image src={rowData.col3} alt={`Image ${rowData.col2}`} width="100" preview />;
	};

	const removalRejectViewContentTemplate = (rowData) => {
		if (rowData.col1 === "Supporting Document:") {
			return <Image src={rowData.col2} width="100" preview />;
		}

		return rowData.col2;
	};

	function RemovalRejectView() {
		var document = binaryData.find((o) => o.binaryTypeID == 13);

		var data = [
			{
				col1: "Removal Finding:",
				col2: application?.removal?.removalFinding,
				col3: "Finding Date:",
				col4: formatDate(application?.removal?.findingDate)
			}

			// {
			// 	col1: "Supporting Document:",
			// 	col2: document?.binaryData,
			// 	col3: "",
			// 	col4: ""
			// }
		];

		var res = [
			{
				col1: application?.removal?.notes
			}
		];

		return (
			<div>
				<DataTable
					className="remove-border"
					header={header("Investigation Details")}
					size="small"
					scrollable={true}
					value={data}
					dataKey="id"
					responsiveLayout="scroll"
					style={{ width: "100%" }}
					emptyMessage="No documents"
					loading={binaryLoading}
				>
					<Column style={{ width: "250px" }} field="col1" body={(e) => <b>{e.col1}</b>}></Column>
					<Column style={{ width: "250px" }} field="col2" body={removalRejectViewContentTemplate}></Column>
					<Column style={{ width: "250px" }} field="col3"></Column>
					<Column field="col4" />
				</DataTable>
				<br />
				<DataTable
					className="remove-border"
					header={header("Finding Notes")}
					size="small"
					scrollable={true}
					value={res}
					dataKey="id"
					responsiveLayout="scroll"
					style={{ width: "100%" }}
					emptyMessage="No documents"
					loading={binaryLoading}
				>
					<Column style={{ width: "100%" }} field="col1" body={(e) => e.col1}></Column>
					{/* <Column style={{ width: "100%" }} field="col2" body={removalRejectViewContentTemplate}></Column> */}
				</DataTable>
			</div>
		);
	}

	function BinaryDataView() {
		var data = [];

		for (const item of binaryData) {
			data.push({
				col1: "Type:",
				col2: item?.binaryType,
				col3: item?.binaryData,
				col4: ""
			});
		}

		return (
			<div>
				<GenericUploadFileTable
					isGenericView={true}
					header={header("Documents")}
					setDocuments={() => { }}
					showAction={false}
					documents={binaryData.map((data) => {
						data.title = data?.binaryType;
						data.binaryType = data?.binaryType;
						data.description = data?.description;
						data.ext = data?.fileExt;
						return data;
					})}
				/>
				<br />
			</div>
		);
	}

	function VoterView() {
		var cellphone1;
		var cellphone2;
		var email = "";

		if (voter) {
			for (const contact of voter?.contactDetails || {}) {
				if (contact.contactType.contactTypeID === 2) {
					email = contact.contactDetail;
				} else {
					if (contact.contactIndex === 1) {
						cellphone1 = `${contact?.countryCode?.code || ""}${contact.contactDetail}`;
					} else {
						cellphone2 = `${contact?.countryCode?.code || ""}${contact.contactDetail}`;
					}
				}
			}
		}
		var inelegibilityReasons = voter?.ineligibilityDetails?.at(0)?.ineligibilityReason || "";

		if (voter?.ineligibilityDetails && voter?.eligibleStatus == "N") {
			inelegibilityReasons = voter?.ineligibilityDetails
				.filter((detail) => detail?.active)
				.map((detail) => detail.ineligibilityReason)
				.join(", ");
		} else {
			inelegibilityReasons = "";
		}

		const { displayFirstName, displayMiddleName } = splitNameFields(
			voter?.firstname,
			voter?.middlename
		);

		const data = [
			{
				col1: "National ID:",
				col2: voter?.idNumber,
				col3: "Registration Number:",
				col4: voter?.registrationNumber
			},
			{
				col1: "Surname:",
				col2: voter?.surname,
				col3: "Firstname:",
				col4: displayFirstName
			},
			{
				col1: "Middle Name:",
				col2: displayMiddleName,
				col3: "Date Of Birth:",
				col4: formatDate(voter?.dateOfBirth?.split(" ")[0])
			},
			{
				col1: "Gender",
				col2: voter?.gender,
				col3: "Disability:",
				col4: voter?.disability
			},
			{
				col1: "Email:",
				col2: email,
				col3: "Cellphone(1):",
				col4: cellphone1
			},
			{
				col1: "Cellphone(2):",
				col2: cellphone2,
				col3: "Eligibility Status:",
				col4: voter?.eligibleStatus == "Y" ? "Eligible" : "Not Eligible",
				...(application &&
					application?.applicationTypeID != APPLICATION_TYPE_AMENDMENT &&
					voter?.eligibleStatus == "N" && {
					col3: "Ineligibility Reason(s):",
					col4: voter?.ineligibilityReason
				})
			},
			{
				col1: "Deceased:",
				col2: voter?.deceased == "Y" ? "Yes" : "No",
				col3: "",
				col4: ""
			}
		];

		return (
			<div>
				<DataTable
					className="remove-border"
					header={header(`${application?.applicationTypeID == APPLICATION_TYPE_AMENDMENT ? "Original Details" : "Elector"}`)}
					size="small"
					scrollable={true}
					value={data}
					dataKey="id"
					responsiveLayout="scroll"
					style={{ width: "100%" }}
				>
					<Column field="col1" style={{ width: "200px" }} body={(e) => <b>{e.col1}</b>}></Column>
					<Column className="uppercase" field="col2" style={{ width: "350px" }}></Column>
					<Column field="col3" style={{ width: "200px" }} body={(e) => <b>{e.col3}</b>}></Column>
					<Column className="uppercase" field="col4" style={{ width: "350px" }}></Column>
				</DataTable>
				{/* <br />
                <DelimitationView header={header("Demarcation")} village={voter?.village} /> */}
			</div>
		);
	}

	function CaptureView() {
		const data = [
			{
				col1: "Captured By:",
				col2: application?.createdBy,
				col3: "Captured Date:",
				col4: formatDateTimeSeconds(application?.createdDate)
			},
			{
				col1: "Device ID:",
				col2: application?.component?.deviceID,
				col3: "Serial No:",
				col4: application?.component?.serialNo
			}
		];
		return (
			<div>
				<DataTable
					className="remove-border"
					header={header(`Capture Details`)}
					size="small"
					scrollable={true}
					value={data}
					dataKey="id"
					responsiveLayout="scroll"
					style={{ width: "100%" }}
				>
					<Column field="col1" style={{ width: "200px" }} body={(e) => <b>{e.col1}</b>}></Column>
					<Column className="uppercase" field="col2" style={{ width: "350px" }}></Column>
					<Column field="col3" style={{ width: "200px" }} body={(e) => <b>{e.col3}</b>}></Column>
					<Column className="uppercase" field="col4" style={{ width: "350px" }}></Column>
				</DataTable>
			</div>
		);
	}

	function ApproverView() {
		var approver = {};

		if (application?.applicationStatusID == APPLICATION_STATUS_REJECTED) {
			approver = {
				col1: "Rejected By:",
				col2: application?.oversightUser,
				col3: "Rejected Date:",
				col4: formatDateTimeSeconds(application?.updatedDate)
			};
		} else if (application?.applicationStatusID == APPLICATION_STATUS_APPROVED) {
			approver = {
				col1: "Approved By:",
				col2: application?.oversightUser,
				col3: "Approved Date",
				col4: formatDateTimeSeconds(application?.updatedDate)
			};
		}

		const data = [
			approver,
			{
				col1: "Device ID",
				col2: application?.approverComponent?.deviceID,
				col3: "Serial No:",
				col4: application?.approverComponent?.serialNo
			}
		];

		return (
			<div>
				<DataTable
					className="remove-border"
					header={header(`Approval Details`)}
					size="small"
					scrollable={true}
					value={data}
					dataKey="id"
					responsiveLayout="scroll"
					style={{ width: "100%" }}
				>
					<Column field="col1" style={{ width: "200px" }} body={(e) => <b>{e.col1}</b>}></Column>
					<Column className="uppercase" field="col2" style={{ width: "350px" }}></Column>
					<Column field="col3" style={{ width: "200px" }} body={(e) => <b>{e.col3}</b>}></Column>
					<Column className="uppercase" field="col4" style={{ width: "350px" }}></Column>
				</DataTable>

				{application?.removal && application?.applicationStatusID == APPLICATION_STATUS_REJECTED && <RemovalRejectView />}
			</div>
		);
	}

	function NotificationView({ header = "" }) {
		const data = [
			{
				method: "Method:",
				status: "Status",
				message: "Message:",
				destination: "Destination"
			},
			...notitication
		];

		return (
			<>
				<Tooltip target=".message-data" />
				<DataTable
					className="remove-border"
					header={header}
					size="small"
					scrollable={true}
					value={data.length > 1 ? data : []}
					dataKey="id"
					responsiveLayout="scroll"
					style={{ width: "100%" }}
					emptyMessage="No results found"
				>
					<Column style={{ width: "200px" }} body={(e, row) => (row.rowIndex == 0 ? <b>{e.method}</b> : e.method)}></Column>
					<Column
						className="uppercase"
						// style={{ width: "250px" }}
						body={(e, row) => (row.rowIndex == 0 ? <b>{e.status}</b> : e.status)}
					></Column>
					<Column style={{ width: "200px" }} body={(e, row) => (row.rowIndex == 0 ? <b>{e.destination}</b> : e.destination)}></Column>
					<Column
						className="uppercase"
						body={(e, row) =>
							row.rowIndex == 0 ? (
								<b>{e.message}</b>
							) : (
								<span
									className="message-data"
									data-pr-tooltip={`${e.message?.replace(/<[^>]+>/g, "")}`}
									data-pr-position="top"
									data-pr-at="right+5 top"
									data-pr-my="top center-2"
								>
									{e.message.substring(0, 30) + "..."}
								</span>
							)
						}
					></Column>
				</DataTable>
			</>
		);
	}

	function VoterRules() {
		return (
			<div>
				<DataTable
					className="remove-border"
					header={header("Requirements")}
					size="small"
					scrollable={true}
					value={applicationRules}
					dataKey="id"
					loading={rulesLoading}
					responsiveLayout="scroll"
					style={{ width: "100%" }}
				>
					<Column field="col1" body={(e) => renderColumnRule(e, "col1")}></Column>
					<Column field="col1" body={(e) => renderColumnRule(e, "col2")}></Column>
					<Column field="col1" body={(e) => renderColumnRule(e, "col3")}></Column>

					{/* <Column style={{ width: "250px" }} field="name" body={(e) => <b>{e.name}</b>}></Column>
					<Column
						field="broken"
						body={(e) => (
							<>
								{e.broken ? (
									<i
										style={{ fontSize: 10, width: 30, height: 30 }}
										className="p-button-danger p-button-rounded   p-button p-component p-button-icon-only pi pi-times"
									></i>
								) : (
									<i
										style={{ fontSize: 10, width: 30, height: 30 }}
										className="pi pi-check  p-button-success p-button-rounded p-button p-component p-button-icon-only"
									></i>
								)}
							</>
						)}
					></Column> */}
				</DataTable>
				{/* <br />
                <DelimitationView header={header("Demarcation")} village={voter?.village} /> */}
			</div>
		);
	}

	function RegistrationView() {
		var data = [
			{
				col1: "Application Date:",
				col2: formatDate(application?.applicationDate?.split(" ")[0]),
				col3: "Channel:",
				col4: application?.applicationChannel
			},
			{
				col1: "Application Status:",
				col2: application?.applicationStatus,
				col3: "Form Serial Number:",
				col4: application?.formSerialNumber
			},
			{
				col1: "National ID:",
				col2: application?.idNumber,
				col3: "Reference Number:",
				col4: application?.referenceNumber

			},
			{
				col1: "Surname:",
				col2: application?.registration?.surname,
				col3: "First Name:",
				col4: application?.registration?.name,

			},
			{
				col1: "Middle Name:",
				col2: application?.registration.middlename,
				col3: "Date Of Birth:",
				col4: formatDate(application?.registration?.dateOfBirth?.split(" ")[0])
			},
			{
				col1: "Gender:",
				col2: application?.registration?.gender,
				col3: "Disability",
				col4: application?.registration?.disability,

			},
			{
				col1: "Email:",
				col2: application?.registration.email,
				col3: "Cellphone(1):",
				col4: `${application?.registration?.cellPhone1.code}${application?.registration?.cellPhone1.number}`,

			},
			{
				col1: "Cellphone(2):",
				col2: application?.registration?.cellPhone2?.number
					? `${application?.registration?.cellPhone2?.code}${application?.registration?.cellPhone2?.number}`
					: ""
			}
		];


		return (
			<div>
				<DataTable
					className="remove-border"
					header={header(
						"Details",
						<>
							{/* {permission?.tabName === "passed" && <>
								<div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
									<div className="mr-3">Edit</div>

								</div>
							</>} */}
						</>
					)}
					size="small"
					scrollable={true}
					value={data}
					dataKey="id"
					responsiveLayout="scroll"
					style={{ width: "100%" }}
				>
					<Column field="col1" style={{ width: "200px" }} body={(e) => <b>{e.col1}</b>}></Column>
					<Column className="uppercase" field="col2" style={{ width: "350px" }}></Column>
					<Column field="col3" style={{ width: "200px" }} body={(e) => <b>{e.col3}</b>}></Column>
					<Column className="uppercase" field="col4" style={{ width: "350px" }}></Column>
				</DataTable>
				<br />
				<DelimitationView header="Demarcation" village={application?.registration.village} />
				<VoterRules />
			</div>
		);
	}

	function MigrationView() {
		var data = [
			{
				col1: "Application Date:",
				col2: formatDate(application?.applicationDate?.split(" ")[0]),
				col3: "Channel:",
				col4: application?.applicationChannel
			},
			{
				col1: "Application Status:",
				col2: application?.applicationStatus,
				col3: "Reference Number:",
				col4: application?.referenceNumber
			},
			{
				col1: "Old Registration Number:",
				col2: application?.migration?.registrationNo,
				col3: "National ID:",
				col4: application?.idNumber
			},
			{
				col1: "Surname:",
				col2: application?.migration?.surname,
				col3: "First name:",
				col4: application?.migration?.name
			},
			{
				col1: "Date Of Birth:",
				col2: formatDate(application?.migration?.dateOfBirth?.split(" ")[0]),
				col3: "Gender:",
				col4: application?.migration?.sex
			},
			{
				col1: "Disability",
				col2: application?.migration?.disability,
				col3: "Email:",
				col4: application?.migration?.email
			},
			{
				col1: "Cellphone(1):",
				col2: application?.migration?.cellNumberOne,
				col3: "Cellphone(2):",
				col4: application?.migration?.cellNumberTwo
			}
		];

		return (
			<div>
				<DataTable
					className="remove-border"
					header={header(
						"Details",
						<>
							{/* {permission?.tabName === "passed" && <>
								<div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
									<div className="mr-3">Edit</div>

								</div>
							</>} */}
						</>
					)}
					size="small"
					scrollable={true}
					value={data}
					dataKey="id"
					responsiveLayout="scroll"
					style={{ width: "100%" }}
				>
					<Column style={{ width: "200px" }} field="col1" body={(e) => <b>{e.col1}</b>}></Column>
					<Column className="uppercase" style={{ width: "350px" }} field="col2"></Column>
					<Column style={{ width: "200px" }} field="col3" body={(e) => <b>{e.col3}</b>}></Column>
					<Column style={{ width: "350px" }} className="uppercase" field="col4"></Column>
				</DataTable>
				<br />
				<DelimitationView header="Demarcation" village={application?.migration?.village} />
				<VoterRules />
			</div>
		);
	}

	function ObjectionView() {
		var data = [
			{
				col1: "Application Date:",
				col2: formatDate(application?.applicationDate?.split(" ")[0]),
				col3: "Channel:",
				col4: application?.applicationChannel
			},

			{
				col1: "Application Status:",
				col2: application?.applicationStatus,
				col3: "Reference Number:",
				col4: application?.referenceNumber
			},
			{
				col1: "Objection Type:",
				col2: application?.objection?.objectionType,
				col3: "National ID:",
				col4: application?.idNumber
			},
			{
				col1: "Reason:",
				col2: application?.objection?.reason,
				col3: "Notes:",
				col4: application?.objection?.comment
			},
			{
				col1: "Logged By:",
				col2: application?.objection?.lodgedByVoter?.firstname + " " + application?.objection?.lodgedByVoter?.surname,
				col3: "Registration Number:",
				col4: application?.objection?.lodgedByVoter?.registrationNumber
			},
			{
				col1: "Logged Against:",
				col2: application?.objection?.lodgedAgainstVoter?.firstname + " " + application?.objection?.lodgedAgainstVoter?.surname,
				col3: "Registration Number:",
				col4: application?.objection?.lodgedAgainstVoter?.registrationNumber
			}
		];

		return (
			<div>
				<DataTable
					className="remove-border"
					header={header(
						"Details",
						<>
							{/* {permission?.tabName === "passed" && <>
								<div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
									<div className="mr-3">Edit</div>

								</div>
							</>} */}
						</>
					)}
					size="small"
					scrollable={true}
					value={data}
					dataKey="id"
					responsiveLayout="scroll"
					style={{ width: "100%" }}
				>
					<Column style={{ width: "200px" }} field="col1" body={(e) => <b>{e.col1}</b>}></Column>
					<Column className="uppercase" style={{ width: "350px" }} field="col2"></Column>
					<Column style={{ width: "200px" }} field="col3" body={(e) => <b>{e.col3}</b>}></Column>
					<Column style={{ width: "350px" }} className="uppercase" field="col4"></Column>
				</DataTable>
				<br />
				{/* <DelimitationView header="Demarcation" village={application?.migration?.village} />
				<VoterRules /> */}
			</div>
		);
	}

	function TransferView() {
		var data = [
			{
				col1: "Application Date:",
				col2: formatDate(application?.applicationDate?.split(" ")[0]),
				col3: "National ID:",
				col4: application?.idNumber
			},
			{
				col1: "Application Status:",
				col2: application?.applicationStatus,
				col3: "Reference Number:",
				col4: application?.referenceNumber
			}
		];

		const fromVillage = [
			{
				col1: `${changeLang.get("national_delimitation.district")}:`,
				col2: application?.transfer?.fromVillage?.district,
				col3: `${changeLang.get("national_delimitation.constituency")}:`,
				col4: application?.transfer?.fromVillage?.constituency
			},
			{
				col1: `${changeLang.get("national_delimitation.votingCentre")}:`,
				col2: application?.transfer?.fromVillage?.registrationCentre,
				col3: `${changeLang.get("national_delimitation.village")}:`,
				col4: application?.transfer?.fromVillage?.name
			}
		];

		const toVillage = [
			{
				col1: `${changeLang.get("national_delimitation.district")}:`,
				col2: application?.transfer?.toVillage?.district,
				col3: `${changeLang.get("national_delimitation.constituency")}:`,
				col4: application?.transfer?.toVillage?.constituency
			},
			{
				col1: `${changeLang.get("national_delimitation.votingCentre")}:`,
				col2: application?.transfer?.toVillage?.registrationCentre,
				col3: `${changeLang.get("national_delimitation.village")}:`,
				col4: application?.transfer?.toVillage?.name
			}
		];

		return (
			<div>
				<VoterView />
				<br />
				<DataTable
					className="remove-border"
					header={header("Application Details")}
					size="small"
					scrollable={true}
					value={data}
					dataKey="id"
					responsiveLayout="scroll"
					style={{ width: "100%" }}
				>
					<Column field="col1" style={{ width: "200px" }} body={(e) => <b>{e.col1}</b>}></Column>
					<Column className="uppercase" field="col2" style={{ width: "350px" }}></Column>
					<Column field="col3" style={{ width: "200px" }} body={(e) => <b>{e.col3}</b>}></Column>
					<Column className="uppercase" style={{ width: "350px" }} field="col4"></Column>
				</DataTable>
				<DataTable
					className="remove-border transfer-table-header"
					header={"From Village"}
					size="small"
					scrollable={true}
					value={fromVillage}
					dataKey="id"
					responsiveLayout="scroll"
					style={{ width: "100%" }}
				>
					<Column field="col1" style={{ width: "200px" }} body={(e) => <b>{e.col1}</b>}></Column>
					<Column className="uppercase" field="col2" style={{ width: "350px" }}></Column>
					<Column field="col3" style={{ width: "200px" }} body={(e) => <b>{e.col3}</b>}></Column>
					<Column className="uppercase" field="col4" style={{ width: "350px" }}></Column>
				</DataTable>
				<DataTable
					className="remove-border transfer-table-header"
					header={"To Village"}
					size="small"
					scrollable={true}
					value={toVillage}
					dataKey="id"
					responsiveLayout="scroll"
					style={{ width: "100%" }}
				>
					<Column field="col1" style={{ width: "200px" }} body={(e) => <b>{e.col1}</b>}></Column>
					<Column className="uppercase" field="col2" style={{ width: "350px" }}></Column>
					<Column field="col3" style={{ width: "200px" }} body={(e) => <b>{e.col3}</b>}></Column>
					<Column className="uppercase" field="col4" style={{ width: "350px" }}></Column>
				</DataTable>

				{/* <DelimitationView header={header("From")} village={application?.transfer.fromVillage} />
                <br />
                <DelimitationView header={header("To")} village={application?.transfer.toVillage} /> */}
			</div>
		);
	}

	function AmendmentView() {
		console.log(application)
		
		const { displayFirstName, displayMiddleName } = splitNameFields(
			application?.amendment?.name,
			application?.amendment?.middlename
		);
		
		var data = [

			{
				col1: "Application Date:",
				col2: formatDate(application?.applicationDate?.split(" ")[0]),
				col3: "Application Status:",
				col4: application?.applicationStatus
			},
			{
				col1: "Reference Number:",
				col2: application?.referenceNumber,
				col3: "Surname:",
				col4: application?.amendment?.surname,
			},
			{
				col1: "First Name",
				col2: displayFirstName,
				col3: "Middle Name:",
				col4: displayMiddleName
			},
			{
				col1: "Date Of Birth:",
				col2: formatDate(application?.amendment?.dateOfBirth?.split(" ")[0]),
				col3: "Gender:",
				col4: application?.amendment?.gender
			},
			{
				col1: "Disability",
				col2: application?.amendment?.disability,
				col3: "Email:",
				col4: application?.amendment?.email
			},
			{
				col1: "Cellphone(1):",
				col2: application?.amendment?.cellPhone1
					? `${application?.amendment?.cellPhone1?.code || ""}${application?.amendment?.cellPhone1?.number || ""}`
					: "",
				col3: "Cellphone(2):",
				col4: application?.amendment?.cellPhone2?.number
					? `${application?.amendment?.cellPhone2?.code || ""}${application?.amendment?.cellPhone2?.number || ""}`
					: ""
			}
		];

		return (
			<div>
				<VoterView />
				{application && application?.applicationTypeID == APPLICATION_TYPE_REGISTRATION && <RegistrationView />}
				<br />
				<DataTable
					className="remove-border"
					header={header(`${application?.applicationTypeID == APPLICATION_TYPE_AMENDMENT ? "Amended Details" : "Application Details"}`)}
					size="small"
					scrollable={true}
					value={data}
					dataKey="id"
					responsiveLayout="scroll"
					style={{ width: "100%" }}
				>
					<Column field="col1" style={{ width: "200px" }} body={(e) => <b>{e.col1}</b>}></Column>
					<Column className="uppercase" field="col2" style={{ width: "350px" }}></Column>
					<Column field="col3" style={{ width: "200px" }} body={(e) => <b>{e.col3}</b>}></Column>
					<Column className="uppercase" field="col4" style={{ width: "350px" }}></Column>
				</DataTable>
				<br />
				<VoterRules />
			</div>
		);
	}

	function SuspensionView() {
		var hasEndDate = [];
		if (application?.suspension.hasEndDate) {
			hasEndDate.push({
				col1: "Start Date:",
				col2: formatDate(application?.suspension?.startDate),
				col3: "End Date:",
				col4: formatDate(application?.suspension?.endDate)
			});
		}

		var data = [
			{
				col1: "Application Date:",
				col2: formatDate(application?.applicationDate?.split(" ")[0]),
				col3: "Reason:",
				col4: application?.suspension?.suspensionReason
			},
			{
				col1: "Application Status:",
				col2: application?.applicationStatus,
				col3: "Reference Number:",
				col4: application?.referenceNumber
			},
			{
				col1: "Has End Date",
				col2: <Badge severity={hasEndDate.length > 0 ? "success" : "danger"} value={hasEndDate.length > 0 ? "Yes" : "No"} />,
				col3: "",
				col4: ""
			},
			...hasEndDate
		];

		var res = [
			{
				col1: application?.suspension?.notes
			}
		];

		return (
			<div>
				<VoterView />
				<br />
				<DelimitationView header="Demarcation" village={voter?.village} />
				<br />
				<DataTable
					className="remove-border"
					header={header("Suspension Details")}
					size="small"
					scrollable={true}
					value={data}
					dataKey="id"
					responsiveLayout="scroll"
					style={{ width: "100%" }}
				>
					<Column field="col1" style={{ width: "200px" }} body={(e) => <b>{e.col1}</b>}></Column>
					<Column className="uppercase" field="col2" style={{ width: "350px" }}></Column>
					<Column field="col3" style={{ width: "200px" }} body={(e) => <b>{e.col3}</b>}></Column>
					<Column className="uppercase" field="col4" style={{ width: "350px" }}></Column>
				</DataTable>
				<DataTable
					className="remove-border"
					header={header("Notes")}
					size="small"
					scrollable={true}
					value={res}
					dataKey="id"
					responsiveLayout="scroll"
					style={{ width: "100%" }}
					emptyMessage="No documents"
					loading={binaryLoading}
				>
					<Column style={{ width: "100%" }} field="col1" body={(e) => e.col1}></Column>
					{/* <Column style={{ width: "100%" }} field="col2" body={removalRejectViewContentTemplate}></Column> */}
				</DataTable>
			</div>
		);
	}

	function ReinstatementView() {
		var data = [
			{
				col1: "Application Date:",
				col2: formatDate(application?.applicationDate?.split(" ")[0]),
				col3: "Registration Number:",
				col4: application?.reinstatement?.registrationNumber
			},
			{
				col1: "Application Status:",
				col2: application?.applicationStatus,
				col3: "Reference Number:",
				col4: application?.referenceNumber
			},
			{
				col1: "Surname:",
				col2: application?.reinstatement?.surname,
				col3: "First name:",
				col4: application?.reinstatement?.name
			},
			{
				col1: "Reason:",
				col2: application?.reinstatement?.reinstatementReason,
				col3: "Notes:",
				col4: application?.reinstatement?.notes
			}
		];

		return (
			<div>
				<VoterView />
				<br />
				<DelimitationView header="Demarcation" village={voter?.village} />
				<br />
				<DataTable
					className="remove-border"
					header={header("Reinstatement Details")}
					size="small"
					scrollable={true}
					value={data}
					dataKey="id"
					responsiveLayout="scroll"
					style={{ width: "100%" }}
				>
					<Column field="col1" style={{ width: "200px" }} body={(e) => <b>{e.col1}</b>}></Column>
					<Column className="uppercase" field="col2" style={{ width: "350px" }}></Column>
					<Column field="col3" style={{ width: "200px" }} body={(e) => <b>{e.col3}</b>}></Column>
					<Column className="uppercase" field="col4" style={{ width: "350px" }}></Column>
				</DataTable>
				<VoterRules />
			</div>
		);
	}

	function RemovalView() {
		var data = [
			{
				col1: "Application Status:",
				col2: application?.applicationStatus,
				col3: "Reference Number:",
				col4: application?.referenceNumber
			},
			{
				col1: "Surname:",
				col2: application?.removal?.surname,
				col3: "Name:",
				col4: application?.removal?.name
			},
			{
				col1: "Last Known Address of Deceased",
				col2: application?.removal?.lastKnownAddress,
				col3: "Date of Birth:",
				col4: formatDate(application?.removal?.dateOfBirth?.split(" ")[0])
			},
			{
				col1: "Gender:",
				col2: application?.removal?.gender,
				col3: "Date of Death:",
				col4: formatDate(application?.removal?.dateOfDeath?.split(" ")[0])
			},
			{
				col1: "Death Reported By",
				col2: application?.removal.deathReportedBy,
				col3: "Address of Person Reporting Death:",
				col4: application?.removal?.addressofReportingPerson
			},
			{
				col1: "Source",
				col2: application?.removal?.applicationSource,
				col3: "",
				col4: ""
			}
		];

		return (
			<div>
				<VoterView />
				<br />
				<DataTable
					className="remove-border"
					header={header("Removal Details")}
					size="small"
					scrollable={true}
					value={data}
					dataKey="id"
					responsiveLayout="scroll"
					style={{ width: "100%" }}
				>
					<Column field="col1" style={{ width: "200px" }} body={(e) => <b>{e.col1}</b>}></Column>
					<Column className="uppercase" field="col2" style={{ width: "350px" }}></Column>
					<Column field="col3" style={{ width: "200px" }} body={(e) => <b>{e.col3}</b>}></Column>
					<Column className="uppercase" field="col4" style={{ width: "350px" }}></Column>
				</DataTable>
				<VoterRules />
			</div>
		);
	}


	function ObjectionView() {

		var app = application?.objection;

		var data = [
			{
				col1: "Application Date:",
				col2: formatDate(application?.applicationDate?.split(" ")[0]),
				col3: "Objection Type:",
				col4: app?.objectionType
			},
			{
				col1: "Application Status:",
				col2: application?.applicationStatus,
				col3: "Reference Number:",
				col4: application?.referenceNumber
			},
			{
				col1: "Application Channel:",
				col2: application?.applicationChannel,
				col3: "",
				col4: ""
			}
		];

		var notes = [
			{
				col1: "Reason for Objection:",
				col2: app?.comment
			},
			{
				col1: "Suggested Action:",
				col2: app?.recommendations
			}
			,
			{
				col1: "Action Taken",
				col2: app?.actionsTaken
			}]

		return (
			<div>
				<DataTable
					className="remove-border"
					header={header("Objection Details")}
					size="small"
					scrollable={true}
					value={data}
					dataKey="id"
					responsiveLayout="scroll"
					style={{ width: "100%" }}
				>
					<Column field="col1" style={{ width: "200px" }} body={(e) => <b>{e.col1}</b>}></Column>
					<Column className="uppercase" field="col2" style={{ width: "300px" }}></Column>
					<Column field="col3" style={{ width: "200px" }} body={(e) => <b>{e.col3}</b>}></Column>
					<Column className="uppercase" field="col4" style={{ width: "350px" }}></Column>
				</DataTable>

				<DataTable
					className="remove-border"
					header={header("Objection Notes")}
					size="small"
					scrollable={true}
					value={notes}
					dataKey="id"
					responsiveLayout="scroll"
					style={{ width: "100%" }}
				>
					<Column style={{ width: "250px" }} field="col1" body={(e) => <b>{e.col1}</b>}></Column>
					<Column className="uppercase" field="col2" style={{ width: "250px" }}></Column>
				</DataTable>
			</div>
		);
	}


	function ObjectionLodgedAgainstVoterView() {

		var app = application?.objection;

		var data = [
			{
				col1: "National ID:",
				col2: app?.lodgedAgainstIDNumber,
				col3: "Surname:",
				col4: app?.lodgedAgainstSurname
			},
			{
				col1: "First Name:",
				col2: app?.lodgedAgainstFirstName,
				col3: "Middle Name:",
				col4: app?.lodgedAgainstMiddleName,
			},
			{
				col1: "Status:",
				col2: <Badge style={{
					height: "100%"
				}} value={app?.lodgedAgainstStatus}
					severity={app?.lodgedAgainstStatusFlag}></Badge>,
				col3: " ",
				col4: ""
			},
		];

		return (
			<div>

				<DataTable
					className="remove-border"
					header={header("Objection Subject Details")}
					size="small"
					scrollable={true}
					value={data}
					dataKey="id"
					// responsiveLayout="stack"

					style={{ width: "100%" }}
				>
					<Column field="col1" style={{ width: "200px" }} body={(e) => <b>{e.col1}</b>}></Column>
					<Column className="uppercase" field="col2" style={{ width: "300px" }}></Column>
					<Column field="col3" style={{ width: "200px" }} body={(e) => <b>{e.col3}</b>}></Column>
					<Column className="uppercase" field="col4" style={{ width: "350px" }}></Column>
				</DataTable>
			</div>
		);
	}

	function ObjectionLodgedByVoterView() {

		var app = application?.objection;

		var data = [
			{
				col1: "National ID:",
				col2: app?.lodgedByIDNumber,
				col3: "Surname:",
				col4: app?.lodgedBySurname
			},
			{
				col1: "First Name:",
				col2: app?.lodgedByFirstName,
				col3: "Middle Name:",
				col4: app?.lodgedByMiddleName,
			},

			{
				col1: "Status:",
				col2: <Badge
					style={{
						height: "100%"
					}}
					value={app?.lodgedByStatus}
					severity={app?.lodgedByStatusFlag}></Badge>,
				col3: "",
				col4: ""

			},

		];

		return (
			<div>

				<DataTable
					className="remove-border"
					header={header("Lodged By Details")}
					size="small"
					scrollable={true}
					value={data}
					dataKey="id"
					responsiveLayout="scroll"
					style={{ width: "100%" }}
				>
					<Column field="col1" style={{ width: "200px" }} body={(e) => <b>{e.col1}</b>}></Column>
					<Column className="uppercase" field="col2" style={{ width: "300px" }}></Column>
					<Column field="col3" style={{ width: "200px" }} body={(e) => <b>{e.col3}</b>}></Column>
					<Column className="uppercase" field="col4" style={{ width: "350px" }}></Column>
				</DataTable>
			</div>
		);
	}

	function CorrectionView() {
		let notes = null;
		let app = null;
		let isTransfer = false;
		if (application?.correction != null) {
			notes = application.correction;
			if (application?.amendment) {
				app = application.amendment;
				isTransfer = false;
			} else if (application?.amendment === null && application?.transfer) {
				app = application.transfer;
				isTransfer = true;
			}
		}
		const formatPhone = (phone) => {
			if (!phone?.number) return "";
			return `${phone?.code || ""} ${phone?.number || ""}`.trim();
		};


		// ----------------------------
		// Basic Correction Details
		// ----------------------------
		const data = [
			{
				col1: "Surname:",
				col2: app?.surname,
				col3: "First Name:",
				col4: app?.name
			},
			{
				col1: "Middle Name:",
				col2: app?.middlename,
				col3: "Gender:",
				col4: app?.gender
			},
			{
				col1: "Disability:",
				col2: app?.disability,
				col3: "Date Of Birth:",
				col4: formatDate(app?.dateOfBirth)
			},
			{
				col1: "Cellphone(1):",
				col2: formatPhone(app?.cellPhone1),
				col3: "Cellphone(2):",
				col4: formatPhone(app?.cellPhone2)
			},

			{
				col1: "Email:",
				col2: app?.email,
				col3: "Correction Notes:",
				col4: notes?.correctionNotes
			}
		];

		// ----------------------------
		// Transfer Villages (Only if transfer)
		// ----------------------------
		const fromVillage = isTransfer
			? [
				{
					col1: `${changeLang.get("national_delimitation.district")}:`,
					col2: app?.fromVillage?.district,
					col3: `${changeLang.get("national_delimitation.constituency")}:`,
					col4: app?.fromVillage?.constituency
				},
				{
					col1: `${changeLang.get("national_delimitation.votingCentre")}:`,
					col2: app?.fromVillage?.registrationCentre,
					col3: `${changeLang.get("national_delimitation.village")}:`,
					col4: app?.fromVillage?.name
				}
			]
			: [];

		const toVillage = isTransfer
			? [
				{
					col1: `${changeLang.get("national_delimitation.district")}:`,
					col2: app?.toVillage?.district,
					col3: `${changeLang.get("national_delimitation.constituency")}:`,
					col4: app?.toVillage?.constituency
				},
				{
					col1: `${changeLang.get("national_delimitation.votingCentre")}:`,
					col2: app?.toVillage?.registrationCentre,
					col3: `${changeLang.get("national_delimitation.village")}:`,
					col4: app?.toVillage?.name
				}
			]
			: [];

		return (
			<div>
				<VoterView />
				<br />

				{
					!isTransfer && (
						<>
							<DataTable
								className="remove-border"
								header={header("Correction Details")}
								size="small"
								scrollable
								value={data}
								dataKey="id"
								responsiveLayout="scroll"
								style={{ width: "100%" }}
							>
								<Column field="col1" style={{ width: "200px" }} body={(e) => <b>{e.col1}</b>}></Column>
								<Column className="uppercase" field="col2" style={{ width: "350px" }}></Column>
								<Column field="col3" style={{ width: "200px" }} body={(e) => <b>{e.col3}</b>}></Column>
								<Column className="uppercase" field="col4" style={{ width: "350px" }}></Column>
							</DataTable>
						</>
					)
				}

				{/* Transfer Details */}
				{isTransfer && (
					<>
						<DataTable
							className="remove-border"
							header={header("Correction Details")}
							size="small"
							scrollable={true}
							value={data}
							dataKey="id"
							responsiveLayout="scroll"
							style={{ width: "100%" }}
						>
							<Column field="col1" style={{ width: "200px" }} body={(e) => <b>{e.col1}</b>}></Column>
							<Column className="uppercase" field="col2" style={{ width: "350px" }}></Column>
							<Column field="col3" style={{ width: "200px" }} body={(e) => <b>{e.col3}</b>}></Column>
							<Column className="uppercase" style={{ width: "350px" }} field="col4"></Column>
						</DataTable>
						<DataTable
							className="remove-border transfer-table-header"
							header={"From Village"}
							size="small"
							scrollable={true}
							value={fromVillage}
							dataKey="id"
							responsiveLayout="scroll"
							style={{ width: "100%" }}
						>
							<Column field="col1" style={{ width: "200px" }} body={(e) => <b>{e.col1}</b>}></Column>
							<Column className="uppercase" field="col2" style={{ width: "350px" }}></Column>
							<Column field="col3" style={{ width: "200px" }} body={(e) => <b>{e.col3}</b>}></Column>
							<Column className="uppercase" field="col4" style={{ width: "350px" }}></Column>
						</DataTable>
						<DataTable
							className="remove-border transfer-table-header"
							header={"To Village"}
							size="small"
							scrollable={true}
							value={toVillage}
							dataKey="id"
							responsiveLayout="scroll"
							style={{ width: "100%" }}
						>
							<Column field="col1" style={{ width: "200px" }} body={(e) => <b>{e.col1}</b>}></Column>
							<Column className="uppercase" field="col2" style={{ width: "350px" }}></Column>
							<Column field="col3" style={{ width: "200px" }} body={(e) => <b>{e.col3}</b>}></Column>
							<Column className="uppercase" field="col4" style={{ width: "350px" }}></Column>
						</DataTable>
					</>
				)}
			</div>
		);
	}


	return (
		<>
			<div className="grid ">
				<EditRegistrationDialog
					application={application}
					onHide={onHide}
					type={application?.applicationTypeID}
				/>
				<ScreenLoader visible={loading} />
				<div className="col-12 lg:col-12 my-1">
					{application && application?.applicationTypeID == APPLICATION_TYPE_OBJECTION && (<>
						<ObjectionView />
						<ObjectionLodgedByVoterView />
						<ObjectionLodgedAgainstVoterView />
						<DelimitationView onView header="Demarcation" village={application?.village} />

					</>)}
					{application && application?.applicationTypeID == APPLICATION_TYPE_REGISTRATION && <RegistrationView />}
					{application && application?.applicationTypeID == APPLICATION_TYPE_MIGRATION && <MigrationView />}
					{application && application?.applicationTypeID == APPLICATION_TYPE_TRANSFER && <TransferView />}
					{application && application?.applicationTypeID == APPLICATION_TYPE_AMENDMENT && <AmendmentView />}
					{application && application?.applicationTypeID == APPLICATION_TYPE_SUSPENSION && <SuspensionView />}
					{application && application?.applicationTypeID == APPLICATION_TYPE_REINSTATEMENT && <ReinstatementView />}
					{application && application?.applicationTypeID == APPLICATION_TYPE_REMOVAL && <RemovalView />}
					{application && application?.applicationTypeID == APPLICATION_TYPE_CORRECTION && <CorrectionView />}

					{application && application?.applicationTypeID && <BinaryDataView />}

					{application && <CaptureView />}
					{application &&
						(application?.applicationStatusID == APPLICATION_STATUS_REJECTED ||
							application?.applicationStatusID == APPLICATION_STATUS_APPROVED) && <ApproverView />}

					{application?.applicationTypeID != APPLICATION_TYPE_REMOVAL && application?.applicationTypeID != APPLICATION_TYPE_CORRECTION && (
						<>{application && <NotificationView header={header("Notifications")} />}</>
					)}

					{/* {application?.channelCategoryID !== CHANNEL_CATEGORY_UNASSISTED && <DeviceInfo header={header("Device Info")} />} */}
				</div>
			</div>
		</>
	);
}
